import type { FaireProductEntity } from "../../entity_types/product";

export const p_7hkrvyku5m: FaireProductEntity = {
  token: "p_7hkrvyku5m",
  type: "product",
  name: "I ❤️ Ranch Dressing Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/36f72ec9de886c3ea3c50c1d4db515719f4944976e6093fae0dbf05f67aa42f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/746dad9e6883de52f8463f72ccfc2097f01ddb90dd9335f380dd9af559a06f8c.jpeg",
    "https://cdn.faire.com/fastly/2be1fff4e2e2655df70c0311bf0dd75580b861131893b7899043c157dab82aa0.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f8650871207cf5f23b3d31c0feb3e5ee50082cb5f2e15f99b5268d54b2cf7131.jpeg",
    "https://cdn.faire.com/fastly/4cce491a80a94458abf922b578a7d2ee963a017fb416f8c007c5af831186c7aa.jpeg"
  ],
  priceDollars: 6.75,
  description: "We can tell already you know how to dress well— If you know how to make a salad taste good, then you know how to pick socks that look good. 😎\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:11.006Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
